<template>
  <div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row dense justify="center">
      <v-radio-group v-model="usertype" mandatory row class="ma-2 no-display">
        <v-radio label="Student" value="Student" color="#0f2027"></v-radio>
        <v-radio label="Employee" value="Employee" color="#0f2027"></v-radio>
      </v-radio-group>
    </v-row>
    <template v-if="show_card">
      <template v-if="load == true">

        <div>
          <v-card class="box">
            <v-card-title class="toolbar">
              <span class="headline">Add User Access to {{ usertype }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" md="9">
                    <v-autocomplete rounded outlined dense v-model="seluser" :items="users" return-object
                      item-text="name" label="Select User" prepend-icon="mdi-account" />

                  </v-col>
                  <v-col cols="12" md="3">
                    <v-chip v-if="seluser.usertype">
                      <v-icon left color="green">mdi-account</v-icon>
                      {{ seluser.usertype }}
                    </v-chip>

                  </v-col>
                  <v-col cols="12" md="12">
                    <v-autocomplete rounded outlined dense :items="access_control" v-model="selaccess"
                      label="Select Access Control" persistent-hint prepend-icon="mdi-menu" />
                  </v-col>
                  <v-col cols="12" md="12">
                    <div v-if="accesses.length > 0">
                      <b> Access Controls for {{ selaccess }} </b>
                      <v-row>
                        <v-col v-for="access in accesses" :key="access.id" cols="6" sm="6" md="3">
                          <v-checkbox v-model="addaccess" :label="access.name" :value="access.id"
                            color="success"></v-checkbox>
                        </v-col>
                      </v-row>
                      <span v-if="addaccess.length == 0">
                        <v-chip>
                          <v-icon left color="red">mdi-exclamation-thick</v-icon>
                          Please select Access
                        </v-chip>
                      </span>
                    </div>

                    <v-btn :disabled="addaccess.length < 1" class="mb-2 button" @click="addAccessToUser">Add Access
                    </v-btn>

                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </div>
        <v-card class="box" v-if="curr_accesses.length > 0">
          <v-simple-table class="elevation-1 mytable" dense v-if="curr_accesses.length > 0">
            <template v-slot:default>
              <caption class="headline toolbar">Access of {{ seluser.username }}</caption>

              <thead>
                <tr>
                  <td colspan="3" align="right">
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
                      style="width: 40%"></v-text-field>
                  </td>
                </tr>
                <br>
                <tr>
                  <th class="text-left">User</th>
                  <th class="text-left">Linking Date</th>
                  <th class="text-left">Division</th>
                  <th class="text-left">Standard</th>
                  <th class="text-left">Section</th>
                  <th class="text-left">Linked By</th>
                  <th class="text-left">Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tablerolefilterdata" :key="item.id">
                  <td>{{ item.user }}</td>
                  <td>{{ item.linkingDate }}</td>
                  <td>{{ item.divisionOffering }}</td>
                  <td>{{ item.standard }}</td>
                  <td>{{ item.section }}</td>
                  <td>{{ item.linkedBy }}</td>
                  <td>
                    <div>
                      <v-avatar style="" size="25" class="delete-avatar">
                        <v-icon class="mr-2 delete-v-icon" @click="deleteAccessToUser(item.id)"
                          title="Delete Access">delete</v-icon>
                      </v-avatar>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <br>
      </template>
      <template v-if="load == false">

        <center>
          <h3>Fetching users. Please wait....
            <v-progress-linear style="width:25%" rounded indeterminate color="blue" class="mb-0"></v-progress-linear>
          </h3>
        </center>
      </template>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      snackbar_msg: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      search: '',
      load: false,
      seluser: {
        username: '',
        usertype: ''
      },
      addaccess: [],
      seluser_usertype: '',
      selaccess: '',
      users: [],
      access_control: [],
      accesses: {},
      curr_accesses: {},
      usertype: "",
      show_card: false,
    }
  },
  mounted() {

  },
  watch: {
    usertype() {
      this.getUsers()
    },
    seluser() {
      this.getAccess()
    },
    selaccess() {
      this.getAccess()
    },
  },
  methods: {
    getUsers() {
      const formData = {
        ut: this.usertype
      }
      this.load = false
      axios
        .post("/roleManagement/getUsersByType", formData)
        .then(res => {
          if (res.data.flag == "YES") {
            this.users = res.data.users
            this.access_control = ["Section"]
            this.load = true
            this.show_card = true
          }
          else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar)
            this.load = true
            this.show_card = false
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    deleteAccessToUser(accessId) {
      const req_data = {
        accessId: accessId
      }
      axios
        .post("/roleManagement/deleteAccessControl", req_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.addaccess = [];
            this.getAccess()
            this.showSnackbar(
              "#4caf50",
              "User Access Updated Successfully..."
            ); // show snackbar on success
          }
          else {
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    addAccessToUser() {
      const req_data = {
        username: this.seluser.username,
        accessname: this.selaccess,
        accessid: this.addaccess
      }
      axios
        .post("/roleManagement/addAccessControlToUser", req_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.addaccess = [];
            this.getAccess()
            this.showSnackbar(
              "#4caf50",
              "New Access Added Successfully..."
            ); // show snackbar on success
          }
          else {

          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    getAccess() {
      if ((this.seluser.username != '') && (this.selaccess != '')) {
        this.accesses = {}
        this.curr_accesses = {}
        const req_data = {
          username: this.seluser.username,
          access: this.selaccess
        }
        axios
          .post("/roleManagement/getAccessData", req_data)
          .then(res => {
            if (res.data.msg == "200") {
              this.accesses = res.data.accesses || {}
              this.curr_accesses = res.data.curr_accesses || {}
              this.addaccess = []
            }
            else {
            }
          })
          .catch(error => {
            window.console.log(error);
          });
      }
    }
  },
  computed: {
    tablerolefilterdata() {
      return this.curr_accesses.filter(tbdata => {
        return (tbdata.user || '').toLowerCase().includes(this.search.toLowerCase()) ||
          (tbdata.divisionOffering || '').toLowerCase().includes(this.search.toLowerCase()) ||
          (tbdata.standard || '').toLowerCase().includes(this.search.toLowerCase()) ||
          (tbdata.section || '').toLowerCase().includes(this.search.toLowerCase())
      })
    }
  }
}
</script>
<style scoped>
.delete-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.delete-avatar:hover {
  background-color: #b0bec5;
}

.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}

.delete-v-icon:hover {
  color: white;
}
</style>